// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".load {\n  position: fixed;\n  width: 100%;\n  height: 100vh;\n  z-index: 98;\n  text-align: center;\n  background-color: #f8f8f8;\n}\n.load .load-img {\n  width: 26.66667vw;\n  margin-top: 35vh;\n}\n.load div {\n  font-size: 12px;\n  color: #999;\n  margin-top: 5.33333vw;\n}", ""]);
// Exports
module.exports = exports;
